export default "__VITE_ASSET__CnKjuhd___"